import React from 'react'
import style from './sec4.module.css'
import medalIcon from './medal.png'
import peopleIcon from './people.png'
import rocketIcon from './rocket.png'
import timesIcon from './times.png'
import paymentIcon from './money.png'
import { Button } from '@mui/material'

const Sec4 = () => {
    return (
        <div dir='rtl' className={style.box}>
            <div className={style.container}>
                <div className={style.btnBox}>
                    <Button onClick={() => {
                        window.scrollTo(0, document.body.scrollHeight - 1300);
                    }} variant='contained' className={style.syllabusBtn}>לבדיקת התאמה ופרטים</Button>
                </div>

                <div className={style.row}>
                    <div className={style.icon}>
                        <img src={medalIcon} alt="personIcon" />
                    </div>
                    <div>
                        <h1 className={style.extraBold} >הסמכות</h1>
                        <p>במהלך הקורס תצאו עם הסמכה יוקרתית בתחום הענן ואבטחת המידע AWS solution architect אשר תפתח לכם דלת לכל ארגון בארץ ובעולם.</p>
                    </div>
                </div>

                <div className={style.row}>
                    <div className={style.icon}>
                        <img src={rocketIcon} alt="rocketIcon" />
                    </div>
                    <div>
                        <h1 className={style.extraBold} >Bootcamp</h1>
                        <p>עם החברה מספר אחת בארץ בתחום ה-DevOps, חברת DEVELEAP.</p>
                    </div>

                </div>
                <div className={style.row}>
                    <div className={style.icon}>
                        <img src={paymentIcon} alt="paymentIcon" />
                    </div>
                    <div>
                        <h1 className={style.extraBold} >עלות</h1>
                        <p>מוכר על חשבון הפיקדון הצבאי לחיילים משוחררים. אפשרות לקבלת מימון עד  <strong>60%</strong> על ידי המדינה.</p>
                    </div>

                </div>
                <div className={style.row}>
                    <div className={style.icon}>
                        <img src={timesIcon} alt="timesIcon" />
                    </div>
                    <div>
                        <h1 className={style.extraBold} >מתכונת לימוד</h1>
                        <p>9 חודשי הכשרה, 4 ימים בשבוע, 1200 שעות בלימודי בוקר. ההכשרה היעילה ביותר בשוק כיום.</p>
                    </div>

                </div>
                <div className={style.row}>
                    <div className={style.icon}>
                        <img src={peopleIcon} alt="peopleIcon" />
                    </div>
                    <div>
                        <h1 className={style.extraBold} >סדנאות</h1>
                        <p>סדנאות של קואצ׳רים מובילים לבניית ביטחון, שפת גוף, קורות חיים ועוד.</p>
                    </div>

                </div>


                <div className={style.btnBox}>
                    <Button onClick={() => {
                        window.scrollTo(0, document.body.scrollHeight - 1300);
                    }} variant='contained' className={style.syllabusBtn}>לבדיקת התאמה ופרטים</Button>
                </div>

            </div>
        </div>

    )
}

export default Sec4